import { graphql } from 'react-apollo'
import { PERMANENTLY_DELETE_FILES } from '../../graphql/mutations'

export default graphql(PERMANENTLY_DELETE_FILES, { name: 'permanentDeleteFiles' })
